'use strict';

import { Entity } from '../Entity';
import { App } from '../App';
import { User } from './User';
import { UserIntegrationProvider } from '../User/UserIntegrationProvider';

export class UserIntegrationOAuth extends Entity {
  protected id: number;
  protected provider: UserIntegrationProvider;
  protected user: User;
  protected accountId: number;
  protected identifier: string;
  protected needsReconnection: boolean;
  protected agencyAccountId: number;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = parseInt(data.id);

    if (data.user) {
      const user = new User();

      user.hydrate(data.user);

      this.user = user;
    }

    if (data.needsReconnection) {
      this.needsReconnection = data.needsReconnection;
    }

    if (data.identifier) {
      this.identifier = data.identifier;
    }

    if (data.accountId) {
      this.accountId = data.accountId;
    }

    if (data.agencyAccountId) {
      this.agencyAccountId = data.agencyAccountId;
    }

    if (data.provider) {
      const provider = new UserIntegrationProvider();

      provider.hydrate(data.provider);

      this.provider = provider;
    }
  }

  public getProvider() {
    return this.provider;
  }

  public getIdentifier() {
    return this.identifier;
  }

  public getAgencyAccountId() {
    return this.agencyAccountId;
  }

  public getNeedsReconnection() {
    return this.needsReconnection;
  }

  public getAccountId() {
    return this.accountId;
  }

  public getId() {
    return this.id;
  }
}
